import React, { memo } from 'react';
// import { useHistory } from 'react-router-dom';
import { List } from 'appkit-react';
import { ArchiveCard as ListItem } from '@components';
// import '@style/modules/project/projectList.scss';
import '../../../../styles/modules/project/projectList.scss';

function ProjectsListView({ data }) {
  return (
    <List className="project-list-wrapper">
      {data.map((item) => (
        <ListItem
          // onClick={handleClick}
          key={`project-list-${item.projectId}`}
          data={item}
          // settingClick={click}
          // onDelete={handleDelete}
          // onPin={handlePin}
        />
      ))}
    </List>
  );
}

export default memo(ProjectsListView);
